'use client';

import { motion } from 'framer-motion';

const values = [
  {
    title: 'Speed Without Compromise',
    description:
      "We believe rapid development shouldn't mean sacrificing quality. Our proven frameworks deliver production-ready code in 28 days.",
  },
  {
    title: 'Founder-First Approach',
    description:
      'We understand startup challenges. Our transparent pricing and flexible process are designed to help founders validate ideas quickly.',
  },
  {
    title: 'Trust & Transparency',
    description:
      'No hidden costs, no scope creep. What we promise is what you get. Your success is our success.',
  },
  {
    title: 'Launch-Ready Focus',
    description:
      "We don't build prototypes. Every MVP we deliver is production-ready, scalable, and designed for real users.",
  },
];

const AboutSection = () => {
  return (
    <section id="about" className="section-pad section-rule relative z-10 bg-background">
      <div className="mx-auto max-w-7xl">
        <motion.div
          className="mb-14 max-w-2xl"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.6 }}
        >
          <p className="mb-3 font-sans text-xs font-semibold uppercase tracking-[0.2em] text-primary">
            Who we are
          </p>
          <h2 className="mb-3 font-display text-2xl font-bold tracking-tight text-foreground sm:mb-4 sm:text-4xl lg:text-5xl">
            Our core values
          </h2>
          <p className="text-sm leading-relaxed text-text-secondary sm:text-lg">
            How we work with founders who need to move fast and ship right.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 gap-0 sm:grid-cols-2">
          {values.map((value, index) => (
            <motion.div
              key={value.title}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.05 }}
              className="border-t border-border py-8 sm:odd:pr-10 sm:even:border-l sm:even:pl-10"
            >
              <span className="mb-3 block font-sans text-xs font-semibold uppercase tracking-[0.2em] text-primary">
                0{index + 1}
              </span>
              <h3 className="mb-3 font-display text-xl font-semibold text-foreground">
                {value.title}
              </h3>
              <p className="text-sm leading-relaxed text-text-secondary sm:text-base">
                {value.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
